module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('item-media', {
    attrs: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('item-title', {
    attrs: {
      "value": _vm.value
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('item-actions', {
    attrs: {
      "value": _vm.value
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7f4b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/sharedComponents/item/card/index.vue
// module id = 730
// module chunks = 2